import { Observable } from "rxjs";
import { Setting, SettingLink } from "../interfaces/helpTarget";
import { IStageMark } from "../interfaces/stageMark";

// abstract class, not interface to make it work nice with "provides" in app.module :-)
export abstract class AbstractSettingsService {
  public abstract GetSettingLink(
    area: string,
    key: string
  ): Observable<SettingLink>;
  /**
   * Save changes to a Setting
   * @param target the modified Setting
   */
  public abstract SaveSettingLink(target: Setting): Observable<SettingLink>;

  /**
   * Get the StageMark from the server.
   */
  public abstract GetStageMark(): Observable<IStageMark>;
}
